// To be used with react-final-form Fields
import React from 'react'
import PropTypes from 'prop-types'

const FormFieldError = ({ customError, error, touched }) => {
  if (error && touched) { return (<span className="pl-2 small text-danger">{customError || error}</span>) }

  return null
}

FormFieldError.propTypes = {
  customError: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  touched: PropTypes.bool,
}
FormFieldError.defaultProps = {
  customError: undefined,
  error: undefined,
  touched: false,
}

export default FormFieldError
